import { render } from "./CommingSoon.vue?vue&type=template&id=748ab990&scoped=true"
import script from "./CommingSoon.vue?vue&type=script&lang=ts"
export * from "./CommingSoon.vue?vue&type=script&lang=ts"

import "./CommingSoon.vue?vue&type=style&index=0&id=748ab990&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-748ab990"

export default script